import React from "react";

export const EmployerContext = React.createContext({
    workers: undefined,
    setWorkers: () => {},
});